import { useAppQueryString } from '@suntex.fim/nav'

const DEFAULT_HEIGHT = 600
const DEFAULT_WIDTH = 800

// Parses URL search parameters with fallback using strongly typed utility
export const useVideoParams = () => {
  const { mediaId, friendlyname, height, width } = useAppQueryString()

  return {
    mediaId: mediaId ?? '',
    friendlyName: decodeURIComponent(friendlyname ?? 'Video'),
    height: height ?? DEFAULT_HEIGHT,
    width: width ?? DEFAULT_WIDTH
  }
}
